import { withCompInfo } from '@wix/editor-elements-integrations'
import { minimumLabelFontSize } from '../../core/carmi/InputUtils/constants'
import type { ComboBoxInputCSSVars, ComboBoxInputDefinition, ComboBoxInputOption } from './ComboBoxInput'
import { getScaledFont } from '@wix/thunderbolt-becky-root'
import { getCrossEditorsCssVars } from './common'
import { getInputHeightInPx, getLabelPaddingObject } from '../../core/mappers/inputUtils'
import { getHeightInPixels } from '@wix/editor-elements-common-utils'

export const css = withCompInfo<ComboBoxInputCSSVars, ComboBoxInputDefinition>()(
	[
		'compProps',
		'hasResponsiveLayout',
		'compLayout',
		'compSingleLayout',
		'styleProperties',
		'siteFonts',
		'isMobileView',
		'isOneDocMigrated',
	],
	({
		compProps,
		hasResponsiveLayout,
		compLayout,
		compSingleLayout,
		styleProperties,
		siteFonts,
		isMobileView,
		isOneDocMigrated,
	}) => {
		const { textAlignment, labelMargin, labelMobileFontSize, inputHeight, inputHeightMobile } = compProps
		const compInfo = { compLayout, compProps, styleProperties, siteFonts, isMobileView }
		const sharedVars = {
			'--arrowLeftPosition': textAlignment === 'right' ? '0' : 'auto',
			'--arrowRightPosition': textAlignment === 'right' ? 'auto' : '0',
			'--labelMarginBottom': `${labelMargin}px`,
			'--fntlbl': getScaledFont(compInfo, 'fntlbl', isOneDocMigrated, labelMobileFontSize, minimumLabelFontSize),
			'--requiredIndicationDisplay':
				styleProperties.txtlblrq && styleProperties.txtlblrq !== 'transparent' ? 'inline' : 'none',
			...getCrossEditorsCssVars(compInfo, compProps, isOneDocMigrated),
			...getLabelPaddingObject(compProps),
		}
		const height = isOneDocMigrated ? getHeightInPixels(compSingleLayout) : compLayout.height
		return hasResponsiveLayout
			? sharedVars
			: {
				...sharedVars,
				...(!isOneDocMigrated && {
					height: 'auto',
				}),
				'--inputHeight': getInputHeightInPx({
					isMobileView,
					height: height!,
					inputHeight: inputHeight!,
					inputHeightMobile: inputHeightMobile!,
				}),
			}
	}
)

export const props = withCompInfo<any, ComboBoxInputDefinition>()(
	// @ts-ignore
	['compProps', 'compData', 'isMobileView', 'deviceType', 'isInPopupPage', 'skin'],
	// @ts-ignore
	({ compData, compProps, isMobileView, deviceType, isInPopupPage, skin }) => {
		const isMobileViewOrDevice = isMobileView || deviceType === 'Smartphone'

		const {
			options: optionsData = [],
			value: valueFromData = '',
			placeholder: placeholderFromData,
			label,
		} = compData as any
		const { required, isDisabled, designableList, placeholder: placeholderFromProps } = compProps as any
		const placeholder = placeholderFromData || placeholderFromProps

		const options = optionsData.map((optionData: any, index: number) => {
			const optionValue = optionData.value || ''
			return {
				value: optionValue,
				text: optionData.text || '',
				selectedText: optionData.selectedText,
				key: `${index}`,
			}
		}) as Array<ComboBoxInputOption>

		const optionsValues = options.reduce((acc: any, option: ComboBoxInputOption) => {
			acc[option.value] = option
			return acc
		}, {})

		const selectValue = optionsValues[valueFromData] ? valueFromData : ''

		return {
			skin,
			options,
			value: selectValue,
			placeholder,
			label,
			required,
			isDisabled,
			designableList: designableList && !isMobileViewOrDevice,
			isInPopupPage,
		}
	}
)
